export enum CacheStorageKeys {
    SearchIndexStatus = "search-index-status",
    SearchIndexDocuments = "search-index-documents",
    OfflineBooks = "offline-books",
    OfflineDevice = "offline-device",
    OfflineDevices = "offline-devices",
}
